import { render, staticRenderFns } from "./RoomSettings.vue?vue&type=template&id=0c5bc35b&scoped=true"
import script from "./RoomSettings.vue?vue&type=script&lang=ts"
export * from "./RoomSettings.vue?vue&type=script&lang=ts"
import style0 from "./RoomSettings.vue?vue&type=style&index=0&id=0c5bc35b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bc35b",
  null
  
)

export default component.exports